import { create } from "zustand";

interface MfaPending {
  mfaToken: string;
  expiresAtUtc: string;
  destination: string | null;
  resendAvailableAtUtc: string | null;
}

interface AuthStore {
  isAuthenticated: boolean;
  mfaPending: MfaPending | null;
  setAuthenticated: () => void;
  clearAuth: () => void;
  setMfaPending: (pending: MfaPending) => void;
  clearMfaPending: () => void;
  updateMfaPending: (patch: Partial<MfaPending>) => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  isAuthenticated: false,
  mfaPending: null,

  setAuthenticated: () => {
    set({ isAuthenticated: true, mfaPending: null });
  },

  clearAuth: () => {
    set({ isAuthenticated: false, mfaPending: null });
  },

  setMfaPending: (pending) => {
    set({ mfaPending: pending });
  },

  clearMfaPending: () => {
    set({ mfaPending: null });
  },

  updateMfaPending: (patch) => {
    set((state) =>
      state.mfaPending
        ? { mfaPending: { ...state.mfaPending, ...patch } }
        : state,
    );
  },
}));
